import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { ToolTypeListComponent } from './tool-type-list/tool-type-list.component'

export const toolTypeRoutes: Route[] = [
  {
    path: 'tool-types',
    component: ToolTypeListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'tool-types/:id/edit',
    redirectTo: 'tool-types/:id',
    pathMatch: 'full'
  },
  {
    path: 'tool-types/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'ToolType',
        nameSingular: 'Tool Type',
        namePlural: 'Tool Types',
        path: 'tool-types',
        slug: 'taxonomies/tool-types',
        title: 'Tool Types'
      }),
      permission: 'readTaxonomies'
    }
  }
]
